import { render, staticRenderFns } from "./batch-trade.vue?vue&type=template&id=f5f3aac0&scoped=true&"
import script from "./batch-trade.vue?vue&type=script&lang=js&"
export * from "./batch-trade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f3aac0",
  null
  
)

export default component.exports